export const isIos = () => typeof navigator !== 'undefined' && /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
export const isMac = () => typeof navigator !== 'undefined' && /Mac/g.test(navigator.platform);
//# sourceMappingURL=detect-platform.js.map